module.exports = __webpack_public_path__ + "static/media/exit-ic.3d601e4b.svg";